declare const jQuery: any;
const $ = jQuery;


import 'owl.carousel';

//owl carousel
import { initOwlCarousel } from "./owl-carousel";
initOwlCarousel();

//main menu
import { initMainMenu } from "./main-menu";
initMainMenu();

//simple content anchor menu
import { initSimpleContentAnchorMenu } from "./simple-content-anchor-menu";
initSimpleContentAnchorMenu();




$(document).ready(function(){

	//if not admin page, frontend of site only
	if ( !$( "body" ).hasClass( "wp-admin" ) ) {
    // Add smooth scrolling to all links
      $(document).on('click', 'a[href^="#"]', function (event) {
        //event.preventDefault();    
          $('html, body').animate({
              scrollTop: $($.attr(this, 'href')).offset().top-150
          }, 500);
      });
  };

  //remove banner video poster for desktop screens
  var banner_video = document.getElementById('banner-video');
  //if banner-video exists on page and width is equal to or great than 768
  if( banner_video != null && $(window).width() >= 768) { 
      document.getElementById('banner-video').removeAttribute('poster');
  }


});